import { useTranslation } from 'react-i18next';

import { ConsignmentNumberFilter } from '@/features/dashboard-filters';
import { DateRangePicker, type DateRangeValue } from '@/shared/ui/date-range-picker';

import type { DispatchInProgressUrlState } from '../model/types';

interface DispatchInProgressFiltersProps {
  filters: DispatchInProgressUrlState;
  onFilterChange: (key: keyof DispatchInProgressUrlState, value: string) => void;
  onDateRangeChange: (dateFrom: string, dateTo: string) => void;
}

/**
 * In-progress dispatch filter popover content — the legacy filter bar has
 * exactly these two fields plus the header search: consignment number (LIKE)
 * and the actual-dispatch-date range.
 *
 * One column, every field full width: the header filter panel is a narrow
 * column on desktop and a bottom sheet on mobile, so a wrapping row would let
 * the two fields share a line and shrink to their content. Same layout the
 * dashboard filter panels use.
 */
export function DispatchInProgressFilters({
  filters,
  onFilterChange,
  onDateRangeChange
}: DispatchInProgressFiltersProps) {
  const { t } = useTranslation();

  const handleDateRangeChange = (value: DateRangeValue) => {
    onDateRangeChange(value.fromDate || '', value.toDate || '');
  };

  return (
    <div className="flex flex-col gap-4">
      <ConsignmentNumberFilter
        className="w-full"
        value={filters.consignmentNumber}
        onChange={(value) => onFilterChange('consignmentNumber', value)}
      />

      <DateRangePicker
        key={`${filters.dateFrom}|${filters.dateTo}`}
        label={t('journey.actualDispatchTime.label', 'Actual Date of Dispatch')}
        defaultPreset="CR"
        defaultFromDate={filters.dateFrom || undefined}
        defaultToDate={filters.dateTo || undefined}
        onChange={handleDateRangeChange}
        className="w-full"
      />
    </div>
  );
}
